/* Bask & Burrow — scroll-reveal + sticky mobile buy bar.
   Progressive enhancement only: everything is fully visible without this file.
   Load with `defer` in theme.liquid, after bask-burrow.css. */

/* Central affiliate/product link registry — the ONE place to update outbound
   product links across every article, instead of hand-editing dozens of HTML
   files every time a link changes. Every "Shop Now"/"Shop This Enclosure" CTA
   in the article Body HTML carries a stable href (today: a plain, no-tracking
   merchant URL — see initial batch) plus a matching data-bb-affiliate="slug"
   attribute. Leave this map empty and nothing changes (the plain URL already
   baked into each article's href is the fallback). The moment an affiliate
   program approves, or a slug's dropship product page goes live, add ONE
   entry here (slug -> new URL) and every article using that slug updates on
   next page load — no per-article edits required. Keys must match the
   data-bb-affiliate values used in the article HTML. Live slugs and link
   counts across Batch 1 + Batch 2 (verified 2026-07-27):

     zen-habitats 37 · reptile-kages 5 · arcadia 5 · solarmeter 4
     herpstat 4 · bio-dude 3 · animal-plastics 3 · toad-ranch 2
     pangea 2 · mistking 2 · dubia 2 · reptichip 1 · joshs-frogs 1
     govee 1 · chewy 1

   A value may be any URL: an affiliate/tracking link, a marketplace store
   with your tag, or one of our own pages. Values starting with "/" are
   treated as internal and have rel/target stripped automatically.

   Amazon Associates tracking ID: baskandburrow-20
   Append as ?tag=baskandburrow-20 (or &tag=... if the URL already has a
   query string). BEFORE USING IT: confirm baskandburrow.com is listed as
   an approved site on that Associates account — the operating agreement
   requires every site using a tag to be registered to it, and using a tag
   on an unlisted site risks the whole account, not just this site. */
/* ZEN HABITATS -- PER-PRODUCT ROUTING, staged 2026-07-30; LIVE (the 4 zen
   entries below are the live map as of 2026-10-06).

   Originally this was a single 'zen-habitats' slug pointing every link at
   /collections/zen-habitats. That worked but wasted the specificity: 61 of
   the 83 links name a specific size in their anchor or lead-in sentence, so
   sending them all to a collection made the reader re-find the product they
   were just reading about. The article HTML was migrated on 2026-07-30 to
   carry per-size slugs, classified by regex against each link's anchor text
   plus its preceding sentence, with a dry-run review pass. Distribution:

     zen-4x2x2             61   -> /products/4x2x2-...
     zen-2x2x4              7   -> /products/2x2x4-...
     zen-4x2x4              2   -> /products/4x2x4-...
     zen-habitats           6   -> /collections/zen-habitats  (no size named)
     zen-habitats-offsite   7   -> deliberately ABSENT from this map

   The 7 'zen-habitats-offsite' links reference Zen products we do NOT sell:
   the 18x18x24 live plant kit (BB-109, BB-110) and the 6x2x2 / 8x2x4 / 8x4x4
   sizes (BB-039, BB-050, BB-066) -- the large sizes are not even in Shopify
   Collective's catalog, so they cannot be imported. Leaving that slug out of
   this map is intentional: an unmapped slug is skipped by the loop below and
   keeps its baked-in zenhabitats.com href. Do NOT "fix" it by adding an entry.

   Two sizes we stock have zero inbound links because no article names them by
   dimension: 2x2x2 and 4x2x16. Nothing to route; not a bug.

   UPLOAD GATE -- both must be true first:
     1. The 5 enclosure products are imported and the collection exists using
        templates/collection.zen-habitats.json.
     2. Settings -> Taxes is confirmed collecting -- Collective's own settings
        show "Supplier collects taxes: Off," so nothing collects tax until the
        Shopify side is switched on.
   Flipping this early sends live readers to 404s, or to a real checkout
   collecting no tax. Either is worse than leaving the links offsite longer.

   ALSO NOTE, unrelated to Zen: 'arcadia' (41 links) and 'arcadia-reptile' (2)
   are the same brand under two slugs, as are 'pangea' (7) and
   'pangea-reptile' (3). Consolidate before either program goes live, or the
   minority slug silently keeps its unmonetized fallback forever. */
/* THE BIO DUDE -- staged 2026-08-23. Gate below.

   Bio Dude went live as a second Shopify Collective supplier on 2026-08-23
   (26 shelf-stable products; collection handle 'bio-dude', 200 confirmed).
   47 links across the corpus carry data-bb-affiliate="bio-dude" and today
   all point at thebiodude.com, earning nothing now that we sell the range
   ourselves. One map entry routes all of them internally.

   COLLECTION-LEVEL, NOT PER-PRODUCT (deliberately different from Zen):
   Zen justified per-size slugs because 61 of 83 links named a specific
   size. Here 31 of 47 name a product LINE (Terra Sahara/Fauna/Firma/Flora,
   HydroGrow, BioShot) but almost none name a SIZE, and most lines ship in
   both 18qt and 36qt -- so routing to a single product page would guess
   wrong half the time. The collection page shows both sizes side by side.
   Revisit per-product routing only if the article HTML is ever migrated to
   carry size-specific slugs, the way Zen's was.

   TWO LINKS MUST NOT BE ROUTED -- they reference Bio Dude products we do
   NOT sell, exactly like 'zen-habitats-offsite':
     BB-079  "The Bio Dude 96x48x48"      -- large PVC enclosure, not stocked
     BB-113  "Bio Dude's Glow & Grow"     -- plant grow LED, not stocked
   Both need their attribute changed to data-bb-affiliate="bio-dude-offsite"
   BEFORE this entry goes live, or readers land on a substrate collection
   expecting an enclosure or a light. That re-slug is a Matrixify body
   update (both articles are already imported) -- see step 20 in
   08 Matrixify Import/_UPLOAD THESE. 'bio-dude-offsite' is intentionally
   absent from this map so those links keep their baked-in href.

   UPLOAD GATE for the bio-dude entry -- both must be true:
     1. Step 20 (the 2-link re-slug) has been imported.
     2. The Collective shipping setting is fixed -- a live checkout test on
        2026-08-23 returned "Shipping: FREE" on a $39.95 substrate order,
        which is wrong (Bio Dude's rate is $9.95 flat over $75). Routing
        readers to a store that undercharges shipping loses money per order. */
var BB_AFFILIATE_LINKS = {
  // Offsite affiliate:  'bio-dude': 'https://www.thebiodude.com/?ref=CODE',
  // Marketplace w/ tag: 'zoo-med': 'https://www.amazon.com/...?tag=baskandburrow-20',
  'zen-4x2x2':    '/products/4x2x2-reptile-enclosure-the-zen-habitat-3-0?variant=67649957429350',
  // ^ 2026-10-24: opens on PVC / Black. Without a variant the page opened on
  //   Wood / Oak (first in-stock), and our own Zen review warns the wood panels
  //   are "capped at 0-50% humidity" and can't take an under-tank heater, which
  //   is wrong for ball pythons, boas and other humid species. PVC suits every
  //   species, and readers can still switch to wood on the page. Re-check this ID
  //   after any Collective re-sync; an unknown ID just falls back to the default.
  //   (The 2x2x4 and 4x2x4 are PVC-only, so they need no variant.)
  'zen-2x2x4':    '/products/2x2x4-reptile-enclosure-the-zen-habitat-3-0',
  'zen-4x2x4':    '/products/4x2x4-reptile-enclosure-the-zen-habitat-3-0',
  'zen-habitats': '/collections/zen-habitats',
  // 'zen-habitats-offsite' is intentionally omitted -- see the note above.
  'bio-dude':     '/collections/bio-dude',
  // ^ Enabled 2026-10-08. Gate met: (1) step 31 (replaces stale step 20)
  //   re-tags the 17 links naming things we DON'T stock -- bioactive kits,
  //   the 72-qt bulk case, the 96x48x48 enclosure, Glow & Grow, the
  //   isopod+BioShot starter, hardwoods -- to 'bio-dude-offsite'; it must be
  //   live BEFORE this line. (2) Shipping: checkout quotes $0 on Bio Dude
  //   orders (tested $6.95-$139.90, CA/NY/IL/AK/HI); owner decision 2026-09:
  //   free shipping is deliberate.
  // 'bio-dude-offsite' is intentionally omitted -- see the note above.
  'solarmeter':      'https://solarmeterstore.com/products/solarmeter-model65r',
  'solarmeter-6-5r': 'https://solarmeterstore.com/products/solarmeter-model65r',
  // ^ 2026-10-24: moved OFF Amazon (removed from BB_AMAZON_ROUTE below). Amazon
  //   doesn't sell the 6.5 or 6.5R, and every Solarmeter search ("Solarmeter",
  //   "6.5", "6.5R", "6.5R UV Index Meter") put the 6.2R first. Our own Solarmeter
  //   article says the 6.2R is "Not for Ferguson-zone work". All 42 links now open
  //   the 6.5R in Solarmeter's official shop: $249 with a cart. The shop is linked
  //   from the maker's "Where to Buy" page; the maker's own product page is
  //   quote-only. Sold out there on 2026-10-24. This earns nothing, but readers
  //   get the right meter.
};

/* AMAZON ROUTING -- added 2026-10-06 (brands decided 2026-07-27; site
   registration on the Associates account confirmed by the owner 2026-10-06;
   "As an Amazon Associate we earn from qualifying purchases" is on
   /pages/affiliate-disclosure and in the site footer).

   Slugs are per BRAND, not per product: one 'zoo-med' slug covers "Zoo Med
   ReptiSun T5 HO 10.0", "Zoo Med Repti Fogger", a rail-card "Shop Now", etc.
   A single URL per slug would send every one of those to the same page, so
   instead each link is sent to a TAGGED AMAZON SEARCH for the product it
   names:
     - link text names the product  -> search that text
     - generic text ("Shop Now ->", "Shop", or just the brand name)
                                     -> the product card's .bb-p-name, else
                                        the brand on its own
     - brand missing from the text   -> brand prefixed ("6.5R" -> "Solarmeter 6.5R")
     - 'amazon' slug ("shop gram scales") -> leading "shop" dropped
   Value = the brand name to prefix ('' for the generic 'amazon' slug).

   Only links whose data-bb-affiliate is a key below are touched. Citations,
   source links, internal links and every other brand keep their href.
   BB_AFFILIATE_LINKS wins if a slug is ever in both. Remove a line here to
   send that brand back to its baked-in href instantly. */
/* Added 2026-10-07 (research: 10 Business & Compliance/amazon-route-brand-
   research-2026-10-06.json): inkbird and govee — both sell through their own
   official Amazon stores, at or below their own sites' prices, and searches
   for their model names come back clean. Deliberately NOT added: repashy
   (dearer on Amazon than Dubia or Repashy's shop, and the articles quote
   Dubia's prices), arcadia (no official Amazon presence), pangea (lookalike
   diets outrank it), mistking (dearer on Amazon), reptichip and dubia (own
   programs pay the same or more at the same or lower price). */
var BB_AMAZON_TAG = 'baskandburrow-20';
var BB_AMAZON_ROUTE = {
  'zoo-med':         'Zoo Med',
  'exo-terra':       'Exo Terra',
  // 'solarmeter' and 'solarmeter-6-5r' were removed 2026-10-24; see BB_AFFILIATE_LINKS.
  'inkbird':         'Inkbird',
  'govee':           'Govee',
  'amazon':          ''
};
/* Link texts too vague to search as-is (generic 'amazon' slug), mapped to what
   the surrounding sentence actually describes. Keys are lower-case.
   2026-10-24 audit: all 53 distinct searches the site generated were checked on
   Amazon for the first non-sponsored result. Entries marked (10-24) fix searches
   whose top result was the wrong product. A value can be:
     - a search string: the Amazon search to run instead;
     - a full https:// URL: Amazon doesn't carry the product, so the link goes to
       the maker's own page for it (unearned, but the right product);
     - null: Amazon doesn't carry it and the maker has no page for it any more,
       so the link keeps its baked-in href. */
var BB_AMAZON_QUERY_FIX = {
  'scale':                    'digital gram scale',         // BB-142 "a digital gram scale"
  'scales, probes and locks': 'digital gram scale',         // BB-097 instruments list, first item
  'digital probe':            'digital thermometer with remote probe reptile', // BB-098 (10-24: was meat thermometers)
  'probe thermometers':       'digital thermometer with remote probe reptile', // (10-24) "shop probe thermometers", was meat thermometers
  'zoo med reptisun t5 ho 5.0': 'Zoo Med ReptiSun T5 HO 5.0 UVB lamp 24W', // (10-24) was the 13W compact coil the site says to avoid
  'zoo med reptisun 5.0':     'Zoo Med ReptiSun T5 HO 5.0 UVB lamp 24W',   // (10-24) same; every use means the T5 tube
  'zoo med 5.0':              'Zoo Med ReptiSun T5 HO 5.0 UVB lamp 24W',   // (10-24) same
  'govee':                    'Govee H5075 hygrometer',     // (10-24) brand-only "Govee" is always the hygrometer; was a floor lamp
  // (10-24) Amazon shows only REPTI ZOO lookalikes for Exo Terra glass; these are the maker's own pages (sizes verified)
  'exo terra 18x18x24':       'https://exo-terra.com/products/terrariums/natural-terrariums/natural-terrarium-small-tall/',  // PT2607 45x45x60 cm
  'exo terra 36x18x18':       'https://exo-terra.com/products/terrariums/natural-terrariums/natural-terrarium-large-wide/',  // PT2613 90x45x45 cm
  'exo terra 36x18x18 large wide': 'https://exo-terra.com/products/terrariums/natural-terrariums/natural-terrarium-large-wide/',
  'zoo med reptibreeze xl':   'https://zoomed.com/reptibreeze/',   // (10-24) Amazon never shows the XL (NT-13); this page lists it
  'zoo med st-7':             'https://zoomed.com/digital-uv-index-radiometer/',  // (10-24) not on Amazon; Zoo Med's ST-7 page
  'exo terra wet log':        'https://exo-terra.com/?s=wet+log',  // (10-24) not on Amazon; lists Wet Log S / M / L
  'exo terra wet log humid hide': 'https://exo-terra.com/?s=wet+log',
  'exo terra monsoon rs400':  null   // (10-24) Amazon has only spare parts, and Exo Terra no longer lists it
};

function bbAmazonQuery(a, brand) {
  var clean = function (s) {
    return (s || '')
      .replace(/[→»>]+/g, ' ')        // arrows
      .replace(/×/g, 'x')                 // 18×18×24 -> 18x18x24
      .replace(/(\w)['’]s\b/g, '$1')      // Exo Terra's -> Exo Terra
      .replace(/\s+/g, ' ')
      .trim();
  };
  var text = clean(a.textContent);
  var lower = text.toLowerCase();
  var b = brand.toLowerCase();
  var generic = /^(shop|buy|view|see|check)( (it|now|here|price|prices|on amazon))?$/i.test(text) ||
                /^(shop|buy|view|see|check) this\b/i.test(text) ||   // "Shop This Backup", "Shop This Enclosure" (2026-10-07)
                (b && lower === b);
  var q = text;
  if (generic) {
    var card = a.closest('.bb-rail-product, .bb-product-cta, .bb-product, .bb-pick, .bb-card, .bb-buy-box, [data-bb-buy-box]');
    var name = card && card.querySelector('.bb-p-name');
    q = name ? clean(name.textContent) : brand;
  }
  if (!brand) q = q.replace(/^shop\s+/i, '');
  if (Object.prototype.hasOwnProperty.call(BB_AMAZON_QUERY_FIX, q.toLowerCase())) {
    q = BB_AMAZON_QUERY_FIX[q.toLowerCase()];
    if (q === null) return null;            // not sold on Amazon: caller leaves the baked-in href alone
    if (/^https?:\/\//.test(q)) return q;   // not sold on Amazon: caller sends the link to this official product page
  }
  if (brand && q.toLowerCase().indexOf(b) === -1) q = brand + ' ' + q;
  return q || brand;
}

(function () {
  document.documentElement.classList.add('js-enabled');

  var affiliateLinks = document.querySelectorAll('[data-bb-affiliate]');
  affiliateLinks.forEach(function (a) {
    var slug = a.getAttribute('data-bb-affiliate');
    if (!Object.prototype.hasOwnProperty.call(BB_AFFILIATE_LINKS, slug)) {
      if (Object.prototype.hasOwnProperty.call(BB_AMAZON_ROUTE, slug)) {
        var q = bbAmazonQuery(a, BB_AMAZON_ROUTE[slug]);
        if (q) a.href = /^https?:\/\//.test(q) ? q : 'https://www.amazon.com/s?k=' +
          encodeURIComponent(q).replace(/%20/g, '+') + '&tag=' + BB_AMAZON_TAG;
      }
      return;
    }

    var dest = BB_AFFILIATE_LINKS[slug];
    a.href = dest;

    /* A destination starting with "/" is one of our own pages (e.g. we now
       stock the brand and route to /collections/... instead of offsite).
       Those must NOT stay rel="sponsored nofollow" — that markup is correct
       for a paid outbound link, but on an internal link it tells Google not
       to follow us to our own product pages. Strip it, and open in-tab. */
    if (dest.charAt(0) === '/') {
      a.removeAttribute('rel');
      a.removeAttribute('target');
    }
  });

  if (!('IntersectionObserver' in window)) return;

  var revealTargets = document.querySelectorAll('.bb-reveal');
  if (revealTargets.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bb-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  /* Sticky mobile buy bar: show once the real buy box has scrolled out of view. */
  var buyBox = document.querySelector('[data-bb-buy-box]');
  var stickyBar = document.querySelector('.bb-sticky-bar');
  if (buyBox && stickyBar) {
    var buyBoxObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
        });
      },
      { threshold: 0 }
    );
    buyBoxObserver.observe(buyBox);
  }

  /* Auto-generated article table of contents.
     Scans .bb-content for <h2 id="..."> and builds the jump-link list into
     every <ul data-bb-autotoc> found on the page — there are two: the sticky
     desktop rail's list and the collapsible mobile/tablet list near the top
     of the article (see bask-burrow-article.liquid + the .bb-mobile-toc CSS
     breakpoint). Article Body HTML never has to hand-write (and keep in
     sync) either one. No headings with ids = no TOC rendered anywhere,
     fails silently rather than showing an empty box. */
  var tocLists = document.querySelectorAll('[data-bb-autotoc]');
  if (tocLists.length) {
    var headings = document.querySelectorAll('.bb-content h2[id]');
    tocLists.forEach(function (tocList) {
      if (headings.length) {
        var frag = document.createDocumentFragment();
        headings.forEach(function (h) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          frag.appendChild(li);
        });
        tocList.appendChild(frag);
      } else {
        var card = tocList.closest('.bb-rail-card, .bb-mobile-toc');
        if (card) card.style.display = 'none';
      }
    });
  }
})();

/* Keep --header-height accurate after a device rotation.
   ----------------------------------------------------------------------
   Dawn writes --header-height in exactly one place: StickyHeader.setHeaderHeight(),
   called on connect and from a `matchMedia('(max-width: 990px)')` CHANGE listener.
   There is no resize or orientationchange listener anywhere in the theme. A phone
   rotating 390 <-> 844 never crosses 990, so that change event never fires and the
   value stays frozen at whatever the page loaded at.

   That matters here because this store's header height IS width-dependent: the logo
   is 280px wide (not Dawn's 100px default) inside a 1fr/2fr/1fr grid, so it renders
   clamped to ~149px in portrait and its full 280px in landscape. Measured on the real
   theme: .section-header is 71px at 390 wide and 101px at 844 wide — so after a
   rotation the variable is wrong by ~30px.

   Two things read it: Dawn's own `.shopify-section-header-hidden{top:calc(-1 *
   var(--header-height))}`, and the mobile drawer block in bask-burrow.css, where it
   sets the in-flow placeholder height that stops the document from shrinking while the
   header is pinned. A stale value there means the page loses that many pixels of
   reading position when the drawer closes.

   Measure .header-wrapper, NOT .section-header: while the drawer is open the section
   carries an explicit height driven by this very variable, so measuring the section
   would just read its own stale value straight back in.

   Deliberately additive: it only ever writes the same property Dawn writes, using the
   same measurement, so it cannot disagree with the theme — it just keeps it current in
   the cases Dawn misses. */
(function () {
  var header = document.querySelector('.section-header .header-wrapper')
            || document.querySelector('.section-header');
  if (!header) return;

  var pending;
  function syncHeaderHeight() {
    pending = null;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(syncHeaderHeight);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  /* the logo is an <img>; its height settles after load, and web fonts can nudge the
     header too — re-measure once both have landed rather than trusting first paint */
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  schedule();
})();

/* Zen 4x2x2: keep the links on an IN-STOCK PVC option (added 2026-10-24).
   BB_AFFILIATE_LINKS opens the product on PVC / Black, which was the only in-stock
   PVC option on 2026-10-24. If it sells out (Collective re-syncs have flipped Zen
   stock before), Shopify would show that option as "Sold out" on every one of
   these links instead of falling back. So, on pages that have such a link, ask the
   store which options are in stock (one small request to Shopify's own product
   JSON). Then point the links at the first in-stock PVC option, or at the plain
   product page (Shopify picks the first in-stock option) if no PVC option is in
   stock. If the request fails, the links keep the PVC / Black address. */
(function () {
  var links = document.querySelectorAll('a[data-bb-affiliate="zen-4x2x2"]');
  if (!links.length || !window.fetch) return;
  var base = '/products/4x2x2-reptile-enclosure-the-zen-habitat-3-0';
  fetch(base + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
    if (!p || !p.variants) return;
    var pvc = p.variants.filter(function (v) { return v.available && /^pvc$/i.test(v.option1 || ''); })[0];
    var href = pvc ? base + '?variant=' + pvc.id : base;
    Array.prototype.forEach.call(links, function (a) { a.href = href; });
  }).catch(function () {});
})();

/* Mobile pick card (added 2026-10-24).
   ----------------------------------------------------------------------
   Below 920px the article layout collapses to one column and .bb-rail gets
   order:2 (bask-burrow.css), so the rail's product card — each article's one
   recommended pick — renders AFTER the whole article and its FAQ. Measured on
   the size chart at 375x812: article ends at screen 8.9, card at 9.5. 70% of
   search clicks are on mobile, so most readers never reached the pick.

   On narrow screens this MOVES (not copies) the rail's product card(s) — max 2,
   which is the most any article has — to just after "The short version" box
   (fallback: just before the first H2), and moves them back to the rail when
   the screen widens. Moving keeps Shopify's own product-link impression/click
   tracking attached to the same element. Desktop is untouched. If anything is
   missing (no rail card, no short version and no H2) it does nothing, and the
   page behaves exactly as before. */
(function () {
  if (!window.matchMedia) return;
  var content = document.querySelector('.bb-content');
  var rail = document.querySelector('.bb-rail');
  if (!content || !rail) return;
  var cards = Array.prototype.slice.call(rail.querySelectorAll('.bb-rail-product'), 0, 2);
  if (!cards.length) return;

  var after = content.querySelector('.bb-short-version');
  var before = after ? null : content.querySelector('h2');
  if (!after && !before) return;

  var homes = cards.map(function (card) {
    var marker = document.createComment('bb-pick-home');
    card.parentNode.insertBefore(marker, card);
    return marker;
  });

  var slot = document.createElement('div');
  slot.className = 'bb-mobile-pick';
  if (after) after.parentNode.insertBefore(slot, after.nextSibling);
  else before.parentNode.insertBefore(slot, before);

  var style = document.createElement('style');
  /* name/price mirror the site's existing product-box styles (.bb-product-cta) */
  style.textContent = '.bb-mobile-pick{display:flex;flex-direction:column;gap:1rem;margin:0 0 2.1rem;}' +
                      '.bb-mobile-pick .bb-thumb{display:none;}' +
                      '.bb-mobile-pick .bb-p-name{font-weight:600;font-size:1rem;line-height:1.3;}' +
                      '.bb-mobile-pick .bb-p-price{font-family:var(--bb-mono);font-size:0.82rem;font-variant-numeric:tabular-nums;color:var(--bb-bark);}';
  document.head.appendChild(style);

  var mq = window.matchMedia('(max-width: 920px)');
  function place() {
    cards.forEach(function (card, i) {
      if (mq.matches) slot.appendChild(card);
      else homes[i].parentNode.insertBefore(card, homes[i].nextSibling);
    });
    slot.style.display = mq.matches ? '' : 'none';
  }
  place();
  if (mq.addEventListener) mq.addEventListener('change', place);
  else if (mq.addListener) mq.addListener(place);
})();
